export enum LocalStorageKey {
    USER_INFO = "user_info_v3",
    AUTH_TOKEN = "auth_token",
    LAST_TOKEN_REFRESH = "last_token_refresh",
}
